import { useEffect, useState } from "react";
import { X } from "lucide-react";

// Company WhatsApp number — must be in international format without '+' or spaces
const WA_NUMBER = "919979084038";
const PREFILL =
  "Hi GenX Technologies, I'd like to know more about your security solutions.";
const WA_LINK = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(PREFILL)}`;

const DISMISS_KEY = "genx_wa_tip_dismissed";

export default function WhatsAppCta() {
  const [showTip, setShowTip] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(DISMISS_KEY)) return;
    const t = setTimeout(() => setShowTip(true), 4000);
    return () => clearTimeout(t);
  }, []);

  const dismissTip = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowTip(false);
    sessionStorage.setItem(DISMISS_KEY, "1");
  };

  return (
    <div
      data-testid="whatsapp-cta"
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-40 flex items-end gap-3"
    >
      {showTip && (
        <div
          data-testid="whatsapp-cta-tip"
          className="hidden sm:flex items-center bg-white shadow-2xl border border-emerald-100 px-4 py-3 max-w-[260px] mb-1 relative"
          style={{ borderRadius: "12px 12px 4px 12px" }}
        >
          <button
            aria-label="Dismiss"
            onClick={dismissTip}
            className="absolute -top-2 -right-2 h-6 w-6 bg-slate-900 text-white rounded-full flex items-center justify-center shadow-md hover:bg-slate-700 transition-colors"
          >
            <X className="h-3 w-3" />
          </button>
          <div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-emerald-600 font-semibold mb-0.5">
              Quick reply on WhatsApp
            </div>
            <div className="text-sm text-slate-800 leading-snug">
              Chat with our team in seconds.
            </div>
          </div>
        </div>
      )}

      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with GenX Technologies on WhatsApp"
        data-testid="whatsapp-cta-button"
        className="relative group h-14 w-14 md:h-16 md:w-16 flex items-center justify-center rounded-full shadow-[0_8px_30px_rgba(37,211,102,0.45)] hover:shadow-[0_10px_40px_rgba(37,211,102,0.7)] transition-shadow"
        style={{ backgroundColor: "#25D366" }}
      >
        {/* Pulse rings */}
        <span
          aria-hidden="true"
          className="absolute inset-0 rounded-full animate-ping opacity-30"
          style={{ backgroundColor: "#25D366", animationDuration: "2.4s" }}
        />
        <span
          aria-hidden="true"
          className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
          style={{ boxShadow: "0 0 0 6px rgba(37,211,102,0.25)" }}
        />
        {/* Official WhatsApp glyph */}
        <svg
          viewBox="0 0 32 32"
          className="relative h-7 w-7 md:h-8 md:w-8 text-white"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M19.11 17.21c-.31-.16-1.85-.91-2.13-1.01-.29-.11-.49-.16-.7.16-.21.31-.81 1.01-.99 1.22-.18.21-.36.24-.67.08-.31-.16-1.32-.49-2.51-1.55-.93-.83-1.55-1.85-1.73-2.16-.18-.31-.02-.48.13-.64.14-.14.31-.36.46-.54.16-.18.21-.31.31-.51.1-.21.05-.39-.03-.55-.08-.16-.7-1.68-.96-2.3-.25-.6-.51-.52-.7-.53-.18-.01-.39-.01-.6-.01-.21 0-.55.08-.84.39-.29.31-1.1 1.07-1.1 2.61 0 1.54 1.13 3.03 1.29 3.24.16.21 2.23 3.4 5.4 4.77.75.32 1.34.51 1.8.66.76.24 1.45.21 2 .13.61-.09 1.85-.76 2.11-1.49.26-.73.26-1.36.18-1.49-.08-.13-.29-.21-.6-.36zM16.02 5.33c-5.91 0-10.71 4.81-10.71 10.72 0 1.89.5 3.74 1.44 5.37l-1.53 5.6 5.74-1.5a10.66 10.66 0 0 0 5.07 1.29h.01c5.9 0 10.71-4.81 10.71-10.72A10.65 10.65 0 0 0 16.02 5.33zm6.24 16.95a8.86 8.86 0 0 1-6.25 2.58h-.01a8.84 8.84 0 0 1-4.49-1.23l-.32-.19-3.32.87.89-3.23-.21-.33a8.83 8.83 0 0 1-1.35-4.7c0-4.89 3.98-8.87 8.88-8.87a8.84 8.84 0 0 1 6.27 2.6 8.81 8.81 0 0 1 2.6 6.27 8.83 8.83 0 0 1-2.69 6.23z" />
        </svg>
        <span className="sr-only">Open WhatsApp chat</span>
      </a>
    </div>
  );
}
